import { Modal } from "@shared/modal";
import { Video } from "@shared/video";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const OverviewEducationModal = ({ isOpen, onClose }: Props) => (
  <Modal
    size="xl"
    isOpen={isOpen}
    onClose={onClose}
    titleContent={
      <div className="font-bold text-xl">
        Welcome to the Enhanced Overview Page!
      </div>
    }
  >
    <p className="mb-0">
      Drag, drop and save the metrics that matter most to you. Create saved
      views for even faster analysis.
    </p>
    <p>Your Overview page can now look however you want!</p>
    <Video
      title="Welcome to the Enhanced Overview Page!"
      src="https://www.youtube.com/embed/CRiRcXlnNVM?rel=0"
    />
  </Modal>
);
